module.exports = __webpack_public_path__ + "static/media/geraint_english_walsh.e3222fcf.mp3";